import React, { useState } from "react";
import { X, Package } from "lucide-react";
import { bulkSetSfInventory } from "../../services/catalogService";

const ItemInventoryEditor = ({ selectedIds, onClose, onDone }) => {
    const [quantity, setQuantity] = useState("");
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState("");

    const handleSave = async () => {
        const numeric = parseInt(quantity, 10);
        if (quantity.trim() === "" || Number.isNaN(numeric) || numeric < 0) {
            setError("Enter a valid quantity");
            return;
        }
        setSaving(true);
        setError("");
        try {
            const res = await bulkSetSfInventory(selectedIds, numeric);
            if (res.failed && res.failed.length > 0) {
                setError(`${res.failed.length} item(s) failed to update`);
                setSaving(false);
                return;
            }
            onDone();
        } catch (e) {
            setError(e.message || "Failed to update inventory");
            setSaving(false);
        }
    };

    return (
        <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4">
            <div className="bg-white rounded-2xl shadow-2xl w-full max-w-sm overflow-hidden">
                <div className="bg-gradient-to-r from-teal-500 to-blue-600 px-6 py-4 flex items-center justify-between">
                    <h2 className="text-white font-bold text-lg flex items-center gap-2">
                        <Package size={18} /> Set SF Inventory
                    </h2>
                    <button onClick={onClose} className="text-white/70 hover:text-white transition">
                        <X size={20} />
                    </button>
                </div>
                <div className="p-6">
                    <p className="text-sm text-gray-500 mb-1">
                        Updating seller-fulfilled inventory for {selectedIds.length} item{selectedIds.length !== 1 && "s"}.
                    </p>
                    <p className="text-xs text-orange-500 mb-4">
                        This overwrites each item's current SF stock level with the value below. WFS inventory can't be set directly — it reflects what you've physically shipped in.
                    </p>
                    <label className="text-xs font-semibold text-gray-600 mb-1 block">New quantity</label>
                    <input
                        type="text"
                        inputMode="numeric"
                        value={quantity}
                        onChange={(e) => setQuantity(e.target.value)}
                        placeholder="e.g. 50"
                        className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-teal-500 mb-3"
                        autoFocus
                    />
                    {error && <p className="text-xs text-red-500 mb-3">{error}</p>}
                    <div className="flex gap-3">
                        <button
                            onClick={handleSave}
                            disabled={saving}
                            className="flex-1 py-2.5 bg-gradient-to-r from-teal-500 to-blue-600 text-white rounded-xl font-bold hover:opacity-90 transition disabled:opacity-50"
                        >
                            {saving ? "Saving..." : "Apply"}
                        </button>
                        <button
                            onClick={onClose}
                            className="px-4 py-2.5 text-gray-500 hover:text-gray-700 rounded-xl border border-gray-200 hover:bg-gray-50 transition text-sm"
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ItemInventoryEditor;